import React, { useEffect } from 'react';

const PageSEO = ({ 
  title, 
  description, 
  keywords, 
  url, 
  h1, 
  h2, 
  h3 
}) => {
  const baseUrl = 'https://cyborgsapient.com';
  const pageUrl = url || baseUrl;

  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    if (description) {
      metaDesc.content = description;
    }

    // Update or create keywords meta tag
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    if (keywords) {
      metaKeywords.content = keywords;
    }

    // Update or create OG tags
    const ogTags = {
      'og:title': title || document.title,
      'og:description': description || '',
      'og:url': pageUrl,
      'og:type': 'website',
      'og:image': `${baseUrl}/assets/images/logo.png`
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      if (content) {
        let meta = document.querySelector(`meta[property="${property}"]`);
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute('property', property);
          document.head.appendChild(meta);
        }
        meta.content = content;
      }
    });

    // Update or create Twitter Card tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:url': pageUrl,
      'twitter:title': title || document.title,
      'twitter:description': description || '',
      'twitter:image': `${baseUrl}/assets/images/logo.png`
    };

    Object.entries(twitterTags).forEach(([name, content]) => {
      if (content) {
        let meta = document.querySelector(`meta[name="${name}"]`);
        if (!meta) {
          meta = document.createElement('meta');
          meta.name = name;
          document.head.appendChild(meta);
        }
        meta.content = content;
      }
    });

    // Update or create canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = pageUrl;

    // Store H1, H2, H3 data in data attributes for potential use
    // (These are typically rendered in the page content, not as meta tags)
    if (h1 || h2 || h3) {
      document.documentElement.setAttribute('data-seo-h1', h1 || '');
      document.documentElement.setAttribute('data-seo-h2', h2 || '');
      document.documentElement.setAttribute('data-seo-h3', h3 || '');
    }
  }, [title, description, keywords, pageUrl, h1, h2, h3]);

  return null;
};

export default PageSEO;

